import { Action, combineReducers } from "redux";
import { IUserGroupPage } from "source/models/userGroup/userGroupPage";

// State
export interface IUserGroupPageState {
    dataId: number;
    userGroupPage: IUserGroupPage;
}

export interface IUserGroupState {
    page: IUserGroupPageState;
}

// Action type constants
const USERGROUP_SUCCESS = "USERGROUP_SUCCESS";
const USERGROUP_FAILURE = "USERGROUP_FAILURE";

type T_USERGROUP_SUCCESS = typeof USERGROUP_SUCCESS;
type T_USERGROUP_FAILURE = typeof USERGROUP_FAILURE;

// Action types
interface IUserGroupSuccess extends Action {
    type: T_USERGROUP_SUCCESS;
    userGroupPage: IUserGroupPage;
}

interface IUserGroupFailure extends Action {
    type: T_USERGROUP_FAILURE;
}

export type UserGroupAction =
    | IUserGroupSuccess
    | IUserGroupFailure;

//Actions
export const userGroupSuccess = (userGroupPage: IUserGroupPage): IUserGroupSuccess => ({
    type: USERGROUP_SUCCESS,
    userGroupPage
});

export const userGroupFailure = (): IUserGroupFailure => ({
    type: USERGROUP_FAILURE
});

//Reducers
export const userGroupInitialState: IUserGroupState = {
    page: {
        dataId: 0,
        userGroupPage: null
    }
};

const page = (state: IUserGroupPageState = null, action: UserGroupAction) => {
    switch (action.type) {
    case USERGROUP_SUCCESS: {
        const userGroupSuccess = action as IUserGroupSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            userGroupPage: userGroupSuccess.userGroupPage
        };
    }
    case USERGROUP_FAILURE:
        return { ...state };
    }
    return state;
};

//Root reducer
export const userGroupReducer = combineReducers({
    page
});

//Utils